import { appEnvironment } from "../lib/env";
import { supabase } from "../lib/supabase";
import { DemoRepository } from "./DemoRepository";
import type { Repository } from "./Repository";
import { SupabaseRepository } from "./SupabaseRepository";

let repository: Repository | null = null;

export function getRepository(): Repository {
  if (repository) return repository;
  if (appEnvironment.demoMode) {
    repository = new DemoRepository();
    return repository;
  }
  if (!supabase) throw new Error("Supabase has not been configured");
  repository = new SupabaseRepository(supabase);
  return repository;
}
